import AuthInitializer from '@modules/Auth/components/AuthInitializer';
import { PopupConsumerManager } from '@modules/Popups';
import { AppVersionChecker } from '@shared/components/AppVersionChecker';
import { ThemeProvider } from '@shared/components/ui/theme-provider';
import { Toaster } from '@shared/components/ui/shadcn/toaster';
import { GlobalProgressBar } from '@shared/components/ui/GlobalProgressBar';
import { ZendeskWidget } from '@shared/components/integrations/ZendeskWidget';
import { QueryClientProvider } from '@tanstack/react-query';
import { Suspense } from 'react';
import './App.css';
import AppRoutes from './routes/AppRoutes';
import createQueryClient from './shared/services/queryClient';
import { RadixPortalCloser } from '@shared/components/ui/RadixPortalCloser';

const queryClient = createQueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RadixPortalCloser />
      <Suspense>
        <ThemeProvider defaultTheme="dark" storageKey="wrh-theme-mode">
          <AppVersionChecker />
          <Toaster />
          <GlobalProgressBar />
          <AuthInitializer>
            <ZendeskWidget />
            <PopupConsumerManager />
            <AppRoutes></AppRoutes>
          </AuthInitializer>
        </ThemeProvider>
      </Suspense>
    </QueryClientProvider>
  );
}

export default App;
